import React from "react";

export default function SQLServer_CONCAT_PLUS() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_CONCAT_PLUS</h1>
      <p>This is the SQLServer_CONCAT_PLUS component generated from the SQL JSON.</p>
    </div>
  );
}
